import Actions from './Actions/index';
import Fields from './Fields/index';

export {
  Actions,
  Fields,
};


// WEBPACK FOOTER //
// ./src/components/page/TaskDetails/components/index.js